
import { Component, Vue, Prop } from "vue-property-decorator";

interface MultiSelectOption {
  Value: string;
  Label: string;
}

interface MultiSelectResult {
  Option: MultiSelectOption;
  Selected: boolean;
}

export {
  MultiSelectOption
}

@Component
export default class MultiSelect extends Vue {
  @Prop({ required: true })
  private readonly options!: MultiSelectOption[];

  @Prop({ default: false })
  private readonly enableCustom!: boolean;

  @Prop({ default: 'Search for ' })
  private readonly customLabelPrefix!: string;

  @Prop({ default: 'search:' })
  private readonly customValuePrefix!: string;

  @Prop({ default: 5 })
  private readonly previewCount!: number;

  @Prop({ default: 'Search' })
  private readonly searchPlaceholder!: string;

  @Prop({ default: 'No results found' })
  private readonly noResults!: string;

  @Prop({ default: 'transparent' })
  private readonly background!: string;

  @Prop({ default: '#fff' })
  private readonly focusBg!: string;

  @Prop({ default: '0.25em' })
  private readonly itemBorderRad!: string;

  private focused = false;

  private selectedValue: MultiSelectOption[] = [];

  private search = '';

  private searchResults: MultiSelectResult[] = [];

  gotFocus() {
    this.focused = true;
    this.updateSearch();
  }

  defocus() {
    requestAnimationFrame(() => {
      this.focused = false;
    });
  }

  updateSearch() {
    let results: MultiSelectOption[];

    if (this.search.length === 0) {
      results = this.options;
    } else {
      const loweredSearch = this.search.toLowerCase();

      results = this.options.filter((itm) => itm.Label.toLowerCase().indexOf(loweredSearch) !== -1);
    }

    this.searchResults = results
      .map((r) => ({ Option: r, Selected: this.selectedValue.some((s) => s.Value === r.Value) }));

    if (this.enableCustom) {
      this.searchResults.push({
        Option: {
          Label: `${this.customLabelPrefix}${this.search}`,
          Value: `${this.customValuePrefix}${this.search}`,
        },
        Selected: false,
      });
    }
  }

  select(option: MultiSelectResult) {
    if (!this.selectedValue.some((v) => v.Value === option.Option.Value)) {
      this.selectedValue.push(option.Option);

      this.search = '';

      this.updateSearch();

      this.$emit('updated', this.selectedValue);
    } else {
      this.removeItem(option.Option.Value);
    }
  }

  removeItem(value: string) {
    const idx = this.selectedValue.findIndex((itm) => itm.Value === value);

    if(idx !== -1) {
      this.selectedValue.splice(idx, 1);

      this.updateSearch();

      this.$emit('updated', this.selectedValue);
    }
  }

  public setValues(value: string[]): void {
    this.selectedValue = this.options.filter((opt) => value.indexOf(opt.Value) !== -1);
  }

  get previewItems(): MultiSelectOption[] {
    return this.selectedValue.slice(0, this.previewCount - 1);
  }
}
